import { useFetch } from './useFetch'
import type { TenantGroupDTO } from '../types'

export function useTenantGroups() {
  const { data: tenantGroups, isLoading, error } =
    useFetch<TenantGroupDTO[]>('/v1/tenant-groups', [])
  return { tenantGroups, isLoading, error }
}
